import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Save, Mail, MapPin, Shield } from "lucide-react";
import { toast } from "sonner";
import React from "react";

export function Settings() {
  const [emailServiceUrl, setEmailServiceUrl] = useState("");
  const [emailApiKey, setEmailApiKey] = useState("");
  const [geolocationApiKey, setGeolocationApiKey] = useState("");
  const [webhookUrl, setWebhookUrl] = useState("");

  const handleSave = () => {
    // Simulate saving settings
    toast.success("Settings saved successfully!");
  };

  return (
    <div className="space-y-4 lg:space-y-6 max-w-2xl mx-auto">
      <div>
        <h1 className="text-2xl lg:text-3xl font-bold mb-2">Settings</h1>
        <p className="text-sm lg:text-base text-muted-foreground">
          Configure your system settings and API integrations
        </p>
      </div>

      {/* Email Service Settings */}
      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg lg:text-xl">
            <Mail className="w-5 h-5" />
            Email Service Configuration
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label htmlFor="emailServiceUrl" className="text-sm lg:text-base">Email Service URL</Label>
            <Input
              id="emailServiceUrl"
              placeholder="https://api.emailservice.com"
              value={emailServiceUrl}
              onChange={(e) => setEmailServiceUrl(e.target.value)}
              className="text-sm lg:text-base"
            />
            <p className="text-xs lg:text-sm mt-1 text-muted-foreground">
              Base URL for your email service provider
            </p>
          </div>
          <div>
            <Label htmlFor="emailApiKey" className="text-sm lg:text-base">Email API Key</Label>
            <Input
              id="emailApiKey"
              type="password"
              placeholder="Your email service API key"
              value={emailApiKey}
              onChange={(e) => setEmailApiKey(e.target.value)}
              className="text-sm lg:text-base"
            />
            <p className="text-xs lg:text-sm mt-1 text-muted-foreground">
              API key for authentication with your email service
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Geolocation Settings */}
      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg lg:text-xl">
            <MapPin className="w-5 h-5" />
            Geolocation Service
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label htmlFor="geolocationApiKey" className="text-sm lg:text-base">Geolocation API Key</Label>
            <Input
              id="geolocationApiKey"
              type="password"
              placeholder="Your geolocation service API key"
              value={geolocationApiKey}
              onChange={(e) => setGeolocationApiKey(e.target.value)}
              className="text-sm lg:text-base"
            />
            <p className="text-xs lg:text-sm mt-1 text-muted-foreground">
              API key for location-based services (Google Maps, etc.)
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Webhook Settings */}
      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg lg:text-xl">
            <Shield className="w-5 h-5" />
            Webhooks & Security
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label htmlFor="webhookUrl" className="text-sm lg:text-base">Webhook URL</Label>
            <Input
              id="webhookUrl"
              placeholder="https://your-app.com/webhook"
              value={webhookUrl}
              onChange={(e) => setWebhookUrl(e.target.value)}
              className="text-sm lg:text-base"
            />
            <p className="text-xs lg:text-sm mt-1 text-muted-foreground">
              URL to receive webhook notifications for QR code scans
            </p>
          </div>
          <div>
            <Label htmlFor="securityNotes" className="text-sm lg:text-base">Security Notes</Label>
            <Textarea
              id="securityNotes"
              placeholder="Add any security-related notes or configurations..."
              rows={3}
              className="text-sm lg:text-base"
            />
            <p className="text-xs lg:text-sm mt-1 text-muted-foreground">
              Additional security configurations and notes
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Save Button */}
      <div className="flex justify-start">
        <Button onClick={handleSave} className="flex items-center gap-2 w-full sm:w-auto">
          <Save className="w-4 h-4" />
          Save Settings
        </Button>
      </div>
    </div>
  );
}